//==============================================
//==            Liste des tags                ==
//==============================================

/** LIRE INSTRUCTIONS AVANT D'AJOUTER DES RESTRICTIONS : 

==> Pour ajouter un tag vous devez renségner les champs suivant en respectant le format ci-dessous :
==> NOM_DU_TAG doit correspondre exactement au nom tag que vous avez ajouté sur les différents produits concernés par la restriction, dans l'administration Shopify des produits

NOM_DU_TAG : {
    Authorization: true/false,           <= mettre true si le tag autorise la livraison à cette/ces date, mettre false si le tag empèche la livraison à cette/ces date.
    Format: "Day"/"Interval"/"Date",     <= "Day": vous voulez appliquer le tag à une ou plusieurs journée (Lundi, Mardi, ..., Dimanche), 
                                            "Interval": vous voulez appliquer le tag à un interval de dates. (du 10 janvier 2023 au 14 février 2023), 
                                            "Date": vous voulez appliquer le tag à une/plusieurs date(s) précise
    Date: ["VALEUR"],                    <= Si Format="Day" alors VALEUR est un tableau de jour. Ex : ["Lundi", "Mardi", "Jeudi"].
                                            Si Format="Interval" alors VALEUR est un tableau contenant exactement 2 dates JJ/MM/YYYY. Ex : ["10/01/2023","14/02/2023"].
                                            Si Format="Date" alors VALEUR est une/plusieurs date(s) JJ/MM/YYYY.  Ex: ["22/12/2022","23/12/2022"].
                                                /!\ N'oubliez pas les crochets autour de vos valeurs. Si vous avez plusieurs valeur, mettez-lez simplement dans les crochets avec une virgule entre chaque valeur. ["a", "b", "..."]
                                                /!\ Si plusieurs dates sont fourni elles doivent être dans l'ordre chronologique.
                                                /!\ Pour les mois ou jours allant de 1 à 9, ne pas mettre de 0 devant : 1er janvier 2023 = 1/1/2023 au lieu de 01/01/2023
    Message: "VALEUR",                    <= Valeur est le message à afficher en dessus du calendrier pour justifier qu'il soit partielement verouillé.
    DateText: "VALEUR"                   <= Valeur est le message à afficher à côté du produit concerné par la restriction, dans la liste des produits possèdant une restriction
},


EXEMPLES :

Exemple de tag qui autorise les réservations tous les mercredi et jeudi:

dateRestrictionMercrediEtJeudi: {
    Authorization :true,
    Format:"Day",
    Date:["Mercredi","Jeudi"],
    Message:"La livraison de votre commande est authorisé seulement le mercredi et le jeudi, car vous avez dans votre panier des articles possèdant cette restriction.",
    DateText: "Uniquement les mercredi et jeudi"
},

Exemple de tag qui refuse les réservations entre le 23 décembre 2022 et 5 janvier 2023 :

dateRestriction23au5janvier: {
    Authorization :false,
    Format:"Interval",
    Date:["23/12/2022", "5/1/2023"],
    Message:"La livraison de votre commande est impossible entre le 23 décembre 2022 et le 5 janvier 2023, car vous avez dans votre panier des articles possèdant cette restriction.",
    DateText: "Impossible du 23 décembre 2022 au 5 janvier 2023"
},

Exemple de tag qui autorise les réservations que les 23 et 24 décembre 2022 :

dateRestriction23et24dec: {
  Authorization:true,
  Format:"Date",
  Date:["23/12/2022","24/12/2022"],
  Message:"La livraison ou retrait est autorisée uniquement le 23 et 24 décembre car vous avez dans votre panier des articles possédant cette restriction.",
  DateText: "Uniquement les 23 et 24 décembre 2022"
},

*/






// AJOUTER LES RESTRICTIONS ICI EN SUIVANT LES INSTRUCTIONS CI-DESSUS


// En cas de panier présentant plusieurs tag, c'est le message ci-après qui sera affiché.
var MESSAGE_PAR_DEFAUT = "Vous possédez dans votre panier des produits ne pouvant être livrés ou retirés à la même date. Vous pouvez effectuer plusieurs commandes pour obtenir des dates de livraison / retrait distinctes (voir liste des produits ci-dessous pour connaître les dates de livraison / retrait possibles).";


var TAGS = {

  
  dateRestrictionVendrediSamedi: {
    Authorization:true,
    Format:"Day",
    Date:["Vendredi","Samedi"],
    Message:"La livraison ou retrait est autorisée uniquement les vendredis et samedis car vous avez dans votre panier des articles possédant cette restriction.",
    DateText: "Vendredi et samedi uniquement"
  },
  dateRestrictionOBAseptembre: {
    Authorization:true,
    Format:"Date",
    Date:["30/1/2026","31/1/2026"],
    Message:"La livraison ou retrait est autorisée uniquement les 30 et 31 janvier car vous avez dans votre panier des articles possédant cette restriction.",
    DateText: "Uniquement les 30 et 31 janvier 2026"
  },
dateRestrictionGaletteCochonne: {
    Authorization:true,
    Format:"Interval",
    Date:["4/1/2025","25/1/2025"],
    Message: "La livraison ou retrait n'est possible que du 4 au 25 janvier car vous avez dans votre panier la galette cochonne.",
    DateText: "Uniquement du 4 au 25 janvier 2024"
  },
  dateRestrictionNoel: {
    Authorization:true,
    Format:"Interval",
    Date:["18/12/2025","31/12/2025"],
    Message: "La livraison ou retrait est impossible du 18 au 31 décembre 2025 car vous avez dans votre panier des articles ne faisant pas partie de la collection Noël.",
    DateText: "Indisponible du 18 au 31 décembre 2025"
  },
    RestrictionHorsNoel: {
    Authorization:false,
    Format:"Interval",
    Date:["18/12/2025","31/12/2025"],
    Message: "La livraison ou retrait est impossible du 18 au 31 décembre 2025 car vous avez dans votre panier des articles ne faisant pas partie de la collection Noël.",
    DateText: "Indisponible du 18 au 31 décembre 2025"
  },
dateRestrictionGateau: {
    Authorization:false,
    Format:"Interval",
    Date:["11/1/2025","15/1/2025"],
    Message: " ",
    DateText: " "
  },
dateRestrictionChoufarci: {
    Authorization:true,
    Format:"Date",
    Date:["13/2/2025","14/2/2025"],
    Message:"La livraison ou retrait est autorisée uniquement les 13 et 14 février car vous avez dans votre panier des articles possédant cette restriction.",
    DateText: "Uniquement les 13 & 14 février 2025"
  },
dateRestrictionSamedi: {
    Authorization:true,
    Format:"Day",
    Date:["Samedi"],
    Message:"La livraison ou retrait est autorisée uniquement et samedis car vous avez dans votre panier des articles possédant cette restriction.",
    DateText: "Samedi uniquement"
  },
dateRestrictionPCRUI: {
    Authorization:true,
    Format:"Interval",
    Date:["1/3/2025","30/3/2025"],
    Message: "La livraison ou retrait n'est possible que pendant le mois de mars les vendredis et samedis.",
    DateText: "Uniquement du 1er au 29 mars 2025"
  },
  dateRestrictionTourtePaques: {
    Authorization:true,
    Format:"Interval",
    Date:["18/4/2025","19/4/2025"],
    Message: "La livraison ou retrait est autorisée uniquement les 18 et 19 avril car vous avez dans votre panier des articles possédant cette restriction.",
    DateText: "Uniquement du 1er au 15 avril 2025"
  },

dateRestrictionFetedesMeres: {
  Authorization:true,
  Format:"Date",
  Date:["23/5/2025","24/5/2025"],
  Message:"La livraison ou retrait est autorisée uniquement le 23 et 24 mai car vous avez dans votre panier des articles possédant cette restriction.",
  DateText: "Uniquement les 23 et 24 mai 2025"
},

dateRestrictionFetedesPeres: {
  Authorization:true,
  Format:"Interval",
  Date:["3/6/2025","30/6/2025"],
  Message:"La livraison ou retrait est autorisée uniquement le 3 au 30 juin car vous avez dans votre panier des articles possédant cette restriction.",
  DateText: "Uniquement du 3 au 30 juin 2025"
},
  
  dateRestrictionAbonnement: {
    Authorization:true,
    Format:"Date",
    Date:["09/01/2026"],
    Message:"La livraison ou retrait est autorisée uniquement le vendredi 9 janvier car vous avez dans votre panier un abonnement possédant cette restriction.",
    DateText: "Uniquement le 9 janvier 2026"
  },
  
dateRestrictionproduitete: {
  Authorization:true,
  Format:"Interval",
  Date:["3/9/2025","5/10/2025"],
  Message:"La livraison ou retrait est autorisée uniquement jusqu'au 5 octobre car vous avez dans votre panier des articles possédant cette restriction.",
  DateText: "Uniquement jusqu'au 5 octobre 2025"
},

}







/*
=> Done : 
=== 23/11/2022 ===
1) Tester si cart page
2) Si oui, alors tester les différents block elseif (premier block if attribué à false) de tag en regardant si un des .cartItemDataTag match avec le tag concerné
3) Process Interval format 
=== 24/11/2022 ===
4) Date format
5) Day Format
6) Affichant le message configuré au visiteur
7) Refresh la page quand un article est retiré.
=== 25/11/2022 ===
4.1) fix du format Date
8) Détécter les multi-tags 
    => verouiller toutes les jounées du DP
    => afficher un msg en rouge avec la liste des produit incompatible
        => afficher les restrictions pour chaque catégorie de produit.


*/

//============= Helpers functions and GLOBAL Vars ==============
var DEBUG_ENABELED = false; // If true, error and log trace will be displayed into the console. (/!\ Set it to false in production)
var PAGE_LOADED = false; // used to prevent from calling the refresh page while setting the event
var DAYS = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"]; // used to switch from day to position into the DatePicker
var LOOP_TIME = 200; // time to wait betwee two call of the script (ms)

/*
 * This helper convert a string date (Format : JJ/MM/YYYY) to a date object.
 * @return DateObject : the date object of the string given.
 */
function stringToDate(StringDate){
  var [Day, Month, Year] = StringDate.split('/');
  return new Date(Year, parseInt(Month)-1, Day);
}

/**
 * This helper get the year and the month of the 
 * current calendar page.
 *
 * @return Object<String, Int> : containt the index of the month and the year selected in the calendar
 */
function getMonthAndYearOfPage(){
  var Values = {};
  // 1 - get year value
  Values["year"] = parseInt($('.rmdp-header .rmdp-header-values span').eq(1).text()); 

  // 2 - get month value
  var Months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var DPmonth = $('.rmdp-header .rmdp-header-values span').eq(0).text().split(',')[0]; // DP is for DatePicker
  Values["month"] = Months.indexOf(DPmonth.toLowerCase())+1; // month index start at 0 so add one to get the real number.

  return Values;
}

/**
 * This helper wait MS milliseconds.
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
//=========================================================

/**
 * This method determine if the current page is the cart page
 */
function isCartPage() {
  // return 1 if the cart form is found.
  return $('.template-cart').length;
}

/**
 * THis function add event listener on cart 
 * button to refresh the page when an article
 * is removed from the cart.
 */
function initEventOnCart(){
  document.querySelectorAll("button.t4s-quantity-selector, a.t4s-page_cart__remove").forEach((item) => {
    item.addEventListener("click", function(event){
      // This function check if the button still have a correct css class
      if(PAGE_LOADED && (this.classList.contains('t4s-quantity-selector') || this.classList.contains('t4s-page_cart__remove'))){
        // wait 200ms to await the shopify cart process and the refresh the page to update the DOM.
        sleep(200).then((value) => {
          window.location.reload(true); // reload and overrid the local cache
        });
      }
    });
  });
  
  if(DEBUG_ENABELED){
    console.log("Event click on delete buttons set.");
  }

  document.querySelectorAll("div.cart_items.js_cat_items").forEach((item) => {
    item.addEventListener("DOMNodeInserted", function(event){
      if(PAGE_LOADED){
        sleep(200).then((value)=>{
          window.location.reload(true); // reload and overrid the local cache
        });
      }
    });
  });
}

/**
 * This method return an array of tags corresponding
 * to all items tags found in the cart.
 *
 * @return array<string> : Concatenation of all tags found in the carts
 */
function getAllItemTags(){
  var Tags = [];
  var ArticlesByTag = [];
  // 1 - Loop through each items in the cart
  $('li.cartItemData').each(function (index) {
    // 2 - Loop through each Tags
    Tags = Tags.concat($(this).text().replace(/^\s+|\s+$/gm,'').toLowerCase().split(/\r?\n/)); // Add the founded tag into the array (the tag is cleared from all format)
  });

  if(DEBUG_ENABELED){
    console.log("Tag found in the cart")
    console.log([...new Set(Tags)]);
  }
  
  return [...new Set(Tags)]; // return all unique values
}

/**
 * This method return an object of all
 * item sorted by computed tag.
 *
 * @return Object<String, Array<String>> : key = the tagName, values = All item possesing this tag.
 */
function getItemByTag(){
  // 1 - get All computed tag present in the cart
  var Tags = getAllItemTags();
  var ComputedTags = Object.keys(TAGS).filter(value => Tags.includes(value.toLowerCase())); // keep only tags that are processed in the TAGS array.

  // 2 - Sort item according to their tag.
  var itemByTag = {};
  $('li.cartItemData').each(function (index) {
    // 2.1 - Loop through each Tags and found all their tag
    var htmlObject = this;
    var itemTag = $(this).text().replace(/^\s+|\s+$/gm,'').split(/\r?\n/); // Add the founded tag into the array (the tag is cleared from all format)
    
    // 2.2 - Check if one itemTag is computed
    $.each(itemTag, function(index, NameTag){
      if(ComputedTags.indexOf(NameTag) >= 0) {
        if(!itemByTag[NameTag]){
          // 2.3 - if the array has not been created yet, create it.
          itemByTag[NameTag] = [];
        }
        // 2.4 - Add the item name to the TagName table.
        itemByTag[NameTag].push(htmlObject.dataset.name); // Add
      }
    });
  });
  return itemByTag; // Return all table;
}

/**
 * This method return the restriction that need to be
 * applyed on the cart according to the itemsTags.
 *
 * @return Object<Tag>|null : see Tags documentation on the top of this page, return null if no restriction is needed
 */
function getRestrictionsOfCart(){
  // 1 - get Tag from the cart
  var CartTags = getAllItemTags();
  // 2 - loop through registred tags and return the first one found.
  var restriction = []
  $.each(TAGS, function (NameTag, values){
    // check if tag is in the array
    if (CartTags.indexOf(NameTag.toLowerCase()) >= 0) {
      restriction.push(values);
    }
  });
  
  // 3 - can return null if no restriction found
  if(DEBUG_ENABELED){
    console.log("Highest priority tags found :");
    console.log([...restriction]);
  }
  
  return [...restriction];
}

/**
 * This method return true if the given date is
 * in the interval.
 *
 * @param date String : the targeted date (format : JJ/MM/YYYY)
 * @param interval Array<String> : Fisrt and last date (format : JJ/MM/YYYY) of the Interval
 *
 * @return bool : true if the date is between fisrt and last date of the Interval, else return false.
 */
function isDayInInterval(date, Interval){
  // 1 - Create a date object for the target and for interval limits
  var DateCheck = stringToDate(date);
  var DateFrom = stringToDate(Interval[0]);
  var DateTo = stringToDate(Interval[1]);

  return (DateFrom.getTime() <= DateCheck.getTime()) && (DateCheck.getTime() <= DateTo.getTime());
}

/**
 * This method disable a day button in the DatePicker.
 * It replace the button by a identical span that is not clickable.
 * @param HtmlElement element : The button element of the day to disable.
 */
function disableDay(element){
  $(element).attr('style', 'opacity: 0.35');
  $(element).parent().attr('style', 'pointer-events: none');
}

/**
This method will remove the disable date which
date will show in date picker
*/
function removeDisableDay(element){
  $(element).removeAttr('style', 'opacity: 0.35');
  $(element).parent().removeAttr('style', 'pointer-events: none');
}

/**
 * This functions Replace the label under the DatePicker
 * @param {string} text : displayable message
 */
function setSelectDateLabel(text, color){
  // normal section
  var style = 'margin-top:25px;margin-bottom:25px;';
  if(color){
    style = style + 'color:'+color+';';
  }
  
  $('div[class*="identixweb-order-delivery-date-uiHeading"]').each(function (index) {
    $(this).html(text);
    $(this).attr('style',style);
  })  
  // "retrait en boutique" section
  $('div[class*="odd_calender_heading"]').each(function (index) {
    $(this).html(text);
    $(this).attr('style',style);
  })  
}

/**
 * This method return true if the
 * given cell is an active day.
 *
 * @return bool
 */
function isActiveCell(elem){
  return $(elem).find('.sd').length; // Active date contain a button <a>
}

/**
 * This function disable all day
 * of the current page.
 */
function disableAllDay(){
  $('.rmdp-calendar .rmdp-day .sd').each(function(index){
    disableDay(this);
  });
}

/**
 * This method build an HTML msg
 * from each combination of item/restriction
 * to help the client to reorder his cart.
 *
 * @return String : the html string of the msg
 */
function buildHtmlMessageeFromItem(itemByTag){
  var HTMLmessage = "<span style=\"font-size:0.9em;color:#333 !important;display:block;\">";

  $.each(itemByTag, function(tagName, items){
    HTMLmessage = HTMLmessage + "<br>" + TAGS[tagName].DateText +" : " + items.join(', '); // get all item Name and concat them into one string separating them by coma.
  });

  return HTMLmessage + "</span>";
}


/*
 * This method update the calendar UI according to the 
 * given restrictions. 
 *
 * @param Object<Tag> : see Tags documentation on the top of this document.
 */
function ApplyRestrictionOnPage(Restriction){
  if(!Restriction) return; // don't do anything if there is no restiction
  // 1 - Destruct Restriction into subvariables which can be used after
  var {Authorization, Format, Date, Message} = Restriction;

  // 2 - Switch on Format to adapt the process
  switch (Format.toLowerCase()){
    case "day":
      if(DEBUG_ENABELED){
        console.log("The restriction is of type day");
        console.log("day is : ");
        console.log(Date);
      }
      var IndiceToCheck = []; // Contain all indice to treat in the process. e.g.: lundi = [0], lundi & jeudi = [0,3]
      Date.forEach(elem => IndiceToCheck.push(DAYS.indexOf(elem.toLowerCase())));
      $('.rmdp-calendar .rmdp-week').each(function(indexRow){
          var Cells = [...this.children];
          $(Cells).each(function (indexCell){
            // Check if cell is activ so we can process on it
            if(isActiveCell(Cells[indexCell])){
              // The following boolean expression is equal to :
              // if (you should autorise the day in the TAG and the current day is not in it) OR if (you should restrict the day and the current day is the TAG)
              if( (Authorization && !IndiceToCheck.includes(indexCell)) || (!Authorization && IndiceToCheck.includes(indexCell)) ){
                disableDay(Cells[indexCell].getElementsByClassName('sd')[0]);
              } else {
                removeDisableDay(Cells[indexCell].getElementsByClassName('sd')[0]);
              }
            } 
        });
      });
      break;


    case "interval":
      if(DEBUG_ENABELED){
        console.log("The restriction is of type interval");
        console.log("Interval is : ");
        console.log(Date);
      }
      // 2.1 - Loop through each day of the current page
      var monthAndYear = getMonthAndYearOfPage();
      $('.rmdp-calendar .rmdp-day .sd').each(function(index){
        var CurrentDay = $(this).text() + "/" + monthAndYear["month"] + "/" + monthAndYear["year"];
        // The following boolean expression is equal to :
        // if (you should autorise the date in the interval and your not in it) OR if (you should restrict in the interval and your in it)
        if((!isDayInInterval(CurrentDay, Date) && Authorization) || (isDayInInterval(CurrentDay, Date) && !Authorization)){
          disableDay(this); // "this" represent the curent day button
          if (DEBUG_ENABELED){
            console.log("The day " + 
             + " has been disabled.");
          }
        }else{
          if (DEBUG_ENABELED){
            console.log("The day " + CurrentDay + " still be activable.");
          }
        }
      });
      break;

      
    case "date":
      if(DEBUG_ENABELED){
        console.log("The restriction is of type Date");
        console.log("Date is : ");
        console.log(Date);
      }
      // 2.1 - Loop through each day of the current page
      var monthAndYear = getMonthAndYearOfPage();
      $('.rmdp-calendar .rmdp-day .sd').each(function(index){
        var CurrentDay = $(this).text() + "/" + monthAndYear["month"] + "/" + monthAndYear["year"]; // construct the current date (the one found on the datePicker)
        var shouldBeDisabeled = null; // flag to choos is a tile will be disable or not.
       
        // 2.2 - Apply the process on all day present in the Tags Date array.
        Date.every(function(day){
          // The following boolean expression is equal to :
          // if (you should autorise the date in the TAG and the current day is not in it) OR if (you should restrict the date and the current date is the TAG)
          if((CurrentDay === day && !Authorization) || (CurrentDay!== day && Authorization)){
            shouldBeDisabeled = true;
            if (DEBUG_ENABELED){
              console.log("The day " + CurrentDay + " has been disabled.");
            }
            return Authorization; // Check the next day in the TAGS dates;
          }else{
            shouldBeDisabeled = false;
            if (DEBUG_ENABELED){
              console.log("The day " + CurrentDay + " still be activable.");
            }
            return !Authorization; // The day has been found go to the next date on the DatePicker
          }
        });

        
        if(shouldBeDisabeled){
          disableDay(this);
        } else {
          removeDisableDay(this);
        }
      });
      break;

      
    // If you need more specific process, you can add new format here. /!\ Add your new format with lowerCase only to avoid user error.
    default:
      console.error("The restriction format found is unknow. Format found : " + Format + "\n Check the item's TAGS configuration.");
  }
  
  // 3 - end the process by updating the selectDateLabel
  setSelectDateLabel(Message);
}


/** =================================
 *   Cart datePicker MAIN PROCESS : 
 *   All the behavior start here
 * ==================================*/
$(function() {
    // 1 - check if the current page is the cart page
	if(isCartPage()){
      if(DEBUG_ENABELED){
        console.log("This is the cart page. All tags will be checked and the DatePicker will be update acording the restrictions found in the cart.");
      }
      
      // loop every 
      setInterval(function() {
        try{
          // 2 - Init speciale event on the page.
          //PAGE_LOADED = false;
          initEventOnCart();
          PAGE_LOADED = true; // all event are set.

          // 3 - check if sevreal tags found
          if(getRestrictionsOfCart().length > 1){
            // 3.1 - If yes, lock the datePicker and display a special message.
            disableAllDay();

            var Message = MESSAGE_PAR_DEFAUT + buildHtmlMessageeFromItem(getItemByTag());
            setSelectDateLabel(Message, 'red');
            
          }else if (getRestrictionsOfCart().length > 0) { // there is one restriction
            // 3.2 - Call once the Apply Restriction On Page to initilize the DatePicker status.
            ApplyRestrictionOnPage(getRestrictionsOfCart()[0]); 
          }
          // 3.3 - do nothing if no TAGS found
        }catch (error){
          if(DEBUG_ENABELED){
            console.error("ERROR HANDLED : " + error.message + "\n" + error.stack);
          }
        }
      }, 200);
    }
});